import { render } from "./SensorDetail.vue?vue&type=template&id=17bc0fbb&scoped=true"
import script from "./SensorDetail.vue?vue&type=script&lang=js"
export * from "./SensorDetail.vue?vue&type=script&lang=js"

import "./SensorDetail.vue?vue&type=style&index=0&id=17bc0fbb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17bc0fbb"]])

export default __exports__